import { Box, HStack, Body, Icon, Heading } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import { INVITED_BY_CONTRACTOR_LIST_DATA } from '../../../constants';
import HoverMaterials from '../../../assets/videos/Hover_Materials.mp4';
import { Progress } from '../../ui';

const TABS_NAME = INVITED_BY_CONTRACTOR_LIST_DATA.map(
  listItem => listItem.title,
);

interface Props {
  currentIndex: string;
  resetTimer: (title: string) => void;
}

const TabSectionMobile: React.FC<Props> = ({ currentIndex, resetTimer }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const scrollingSection = document.getElementById(
      'better-section-horizontal-scroll',
    );

    if (scrollingSection) {
      if (currentIndex === TABS_NAME[TABS_NAME.length - 1]) {
        scrollingSection.scrollTo({ left: scrollingSection.scrollWidth });
      } else if (currentIndex === TABS_NAME[0]) {
        scrollingSection.scrollTo({ left: 0 });
      }
    }
  }, [currentIndex]);

  const onChange = (title: string) => {
    resetTimer(title);
    const scrollingSection = document.getElementById(
      'better-section-horizontal-scroll',
    );

    if (scrollingSection) {
      if (title === TABS_NAME[TABS_NAME.length - 1]) {
        scrollingSection.scrollTo({ left: scrollingSection.scrollWidth });
      } else if (title === TABS_NAME[0]) {
        scrollingSection.scrollTo({ left: 0 });
      }
    }
  };

  return (
    <Box
      d={{ base: 'flex', tablet: 'none' }}
      w="100%"
      maxW="100%"
      overflow="hidden"
      flexDir="column"
      mt={900}
    >
      <HStack
        id="better-section-horizontal-scroll"
        px={500}
        w="100%"
        alignItems="center"
        overflow="scroll"
        mb={500}
        css={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => {
          const isCurrent = listItem.title === currentIndex;
          return (
            <Box
              onClick={() => onChange(listItem.title)}
              key={listItem.title}
              flexDir="column"
              alignItems="center"
              justifyContent="center"
              flex={1}
              minW="100px"
              h="100%"
              minH="88px"
              maxH="88px"
            >
              <Icon
                size="default"
                icon={listItem.icon}
                mb={200}
                mt={400}
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
              />
              <Body
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                textAlign="center"
                isBold
                size={200}
                mb="auto"
                maxW="90%"
              >
                {listItem.title}
              </Body>
              {isCurrent && !isLoading ? (
                <Progress />
              ) : (
                <Box w="100%" h="2px" />
              )}
            </Box>
          );
        })}
      </HStack>
      {INVITED_BY_CONTRACTOR_LIST_DATA.map(listItem => (
        <Box
          d={listItem.title === currentIndex ? 'flex' : 'none'}
          flexDir="column"
        >
          <Box
            key={listItem.id}
            alignItems="center"
            justifyContent="center"
            w="100%"
            px={500}
          >
            {listItem.title !== 'TRANSPARENCY' ? (
              <Box maxH="355px" key={nanoid()}>
                {listItem.mobileImage}
              </Box>
            ) : (
              <Box maxH="355px">
                <video
                  autoPlay
                  src={HoverMaterials}
                  muted
                  key={nanoid()}
                  playsInline
                />
              </Box>
            )}
          </Box>
          <Box px={500}>
            <Heading
              mt={500}
              size={300}
              isDisplay
              marginBottom={0}
              textAlign="center"
            >
              {listItem.body}
            </Heading>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TabSectionMobile;
